import styles from './Tag.module.css'

export type TagProps = {
  title: string
  isBold?: boolean
  isLight?: boolean
}

export const PhnxTag: React.FC<TagProps> = ({ title, isBold = false, isLight = false }) => {
  return (
    title && (
      <span
        className={`${styles['tag']} ${isBold && styles['bold']} ${isLight && styles['light']}`}
        data-test-bold={isBold ? 'true' : 'false'}
      >
        {title}
      </span>
    )
  )
}
